<!-- ReceiptPrint.vue -->
<template>
  <div :class="['receipt-container', ishide ? 'hidden' : '']">
    <!-- Header -->
    <div class="receipt-header">
      <h1 class="store-name">{{ storeName }}</h1>
      <p class="store-address">{{ storeAddress }}</p>
      <p class="store-phone">{{ storePhone }}</p>
    </div>

    <div class="receipt-divider">================================</div>

    <!-- Transaction Info -->
    <div class="receipt-info">
      <div v-for="(detail, index) in viewdetailtransaksi" :key="index" class="info-row">
        <span>{{ detail.field }}:</span>
        <span v-if="detail.type == 'rupiah'">{{ formatPrice(detail.value) }}</span>
        <span v-if="detail.type == 'date'">{{ formatDate(detail.value) }}</span>
        <span v-else>{{ detail.value }}</span>
      </div>
    </div>

    <div class="receipt-divider">================================</div>

    <!-- Items -->
    <div class="receipt-items">
      <div v-for="(item, index) in items" :key="index" class="item">
        <div class="item-row">
          <div class="item-name">{{ item.name }}</div>
          <div v-if="item.discount_price > 0 && item.status != 'canceled'" class="item-name">
            Discount :
          </div>
          <div v-if="item.discount_applied && item.globalDiscountAmount > 0 && item.status != 'canceled'"
            class="item-name">
            {{ currentGlobalDiscount?.name }} :
          </div>
        </div>
        <div class="item-row">
          <div class="item-detail">
            {{ item.quantity }} x {{ formatPrice(item.price) }}
          </div>
          <div v-if="item.discount_price > 0 && item.status != 'canceled'" class="item-total">
            -{{
              formatPrice(
                (item.discount_price > 0
                  ? item.discount_price * item.quantity
                  : 0)
              )
            }}
          </div>
          <div
            v-if="item.discount_applied && item.globalDiscountAmount > 0 && item.status != 'canceled' && currentGlobalDiscount"
            class="item-total">
            -{{
              formatPrice(
                (item.globalDiscountAmount > 0
                  ? item.globalDiscountAmount * item.quantity
                  : 0)
              )
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="receipt-divider">================================</div>

    <!-- Totals -->
    <div class="receipt-totals">
      <div v-for="(detail, index) in viewdetailtotal" :key="index" class="total-row">
        <span>{{ detail.field }}:</span>
        <span v-if="detail.type != 'rupiah'">{{ detail.value }}</span>
        <span v-else>{{ formatPrice(detail.value) }}</span>
      </div>
      <div class="receipt-divider">-------------------------------</div>
      <div v-for="(detail, index) in viewpayment" :key="index"
        :class="['total-row', detail.field == 'Total Bill' ? 'grand-total' : '']">
        <span>{{ detail.field }}:</span>
        <span v-if="detail.type != 'rupiah'">{{ detail.value }}</span>
        <span v-else>{{ formatPrice(detail.value) }}</span>
      </div>
    </div>

    <div class="receipt-divider">================================</div>

    <!-- Footer -->
    <div class="receipt-footer">
      <p>Terima Kasih Atas Kunjungan Anda</p>
      <p>Simpan struk ini sebagai bukti pembayaran</p>
      <p>{{ formatTime(this.createdAt, 'time') }}</p>
    </div>
  </div>
</template>

<script>import { formatTime } from "@/helpers/formatTime";


export default {
  name: 'ReceiptPrint',
  props: {
    storeName: {
      type: String,
      default: process.env.VUE_APP_STORE_NAME
    },
    storeAddress: {
      type: String,
      default: process.env.VUE_APP_STORE_ADDRESS
    },
    storePhone: {
      type: String,
      default: process.env.VUE_APP_STORE_PHONE
    },
    createdAt: {
      type: Date,
      default: new Date()
    },
    viewdetailtransaksi: {
      type: Array,
      default: () => [
        {
          field: 'No. Invoice',
          value: 'MAKLO10',
          type: 'text'
        },
        {
          field: 'Tanggal',
          value: new Date(),
          type: 'date'
        },
        {
          field: 'Nama Tamu',
          value: 'Erista',
          type: 'text'
        },
        {
          field: 'Kasir',
          value: 'Erista Dwatiga',
          type: 'text'
        },
        {
          field: 'Marketing',
          value: 'Erista Dwatiga',
          type: 'text'
        }
      ]
    },
    items: {
      type: Array,
      default: () => [
        {
          name: 'Sate',
          quantity: 1,
          subtotal: 10000,
          discount_price: 100
        },
        {
          name: 'Nasi Goreng',
          quantity: 1,
          subtotal: 10000,
          discount_price: 0
        }
      ]
    },
    viewdetailtotal: {
      type: Array,
      default: () => [
        {
          field: 'Subtotal',
          value: 10000,
          type: 'rupiah'
        },
        {
          field: 'Tax',
          value: 1000,
          type: 'rupiah'
        },
        {
          field: 'Service Charge',
          value: 1000,
          type: 'rupiah'
        },
        {
          field: 'Total Diskon',
          value: 1000,
          type: 'rupiah'
        }
      ]
    },
    viewpayment: {
      type: Array,
      default: () => [
        {
          field: 'Total Bill',
          value: 20000,
          type: 'rupiah',
          isbold: true,
        },
        {
          field: 'Tunai',
          value: 30000,
          type: 'rupiah',
          isbold: false,
        },
        {
          field: 'Kembalian',
          value: 10000,
          type: 'rupiah',
          isbold: false,
        }
      ]
    },
    ishide: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatTime,
    formatPrice(price) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0
      }).format(price);
    },
    formatDate(date) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Intl.DateTimeFormat('id-ID', options).format(date);
    }
  },
}
</script>

<style>
@media print {
  @page {
    margin-left: 0;
    size: 63.4mm auto;
  }

  body * {
    visibility: hidden;
  }

  .receipt-container,
  .receipt-container * {
    visibility: visible;
  }

  .receipt-container {
    position: absolute;
    left: 0;
    top: 0;
  }
}

.receipt-container {
  width: 63.4mm;
  padding: 2mm;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
}

.receipt-header {
  margin-bottom: 10px;
}

.store-name {
  font-size: 16px;
  font-weight: medium;
  margin: 0 0 5px 0;
}

.store-address,
.store-phone {
  margin: 0;
  font-size: 12px;
}

.receipt-divider {
  margin: 5px 0;
  font-size: 12px;
}

.receipt-info {
  text-align: left;
  margin: 10px 0;
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin: 2px 0;
}

.receipt-items {
  text-align: left;
  margin: 10px 0;
}

.item {
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
}

.item-name {
  font-weight: medium;
}

.item-detail {
  font-size: 11px;
}

.item-discount {
  font-size: 11px;
  color: #e74c3c;
  text-align: right;
  margin-top: 2px;
}

.item-total {
  text-align: right;
}

.receipt-totals {
  text-align: right;
  margin: 10px 0;
}

.total-row {
  display: flex;
  justify-content: space-between;
  margin: 2px 0;
}

.grand-total {
  font-weight: weight;
  font-size: 14px;
}

.receipt-footer {
  margin-top: 10px;
  font-size: 11px;
}

.receipt-footer p {
  margin: 2px 0;
}
</style>
